export default __webpack_public_path__ + "static/media/heart-cf.5b4a3f6d.svg";